module.exports = __webpack_public_path__ + "img/1_008.25400398.jpg";